module.exports = __webpack_public_path__ + "2d7604fbc6415b014deee7b0f925c77e.svg";